import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Municipio } from "../../../../services/Municipio";

export const useMunicipioLista = () => {
  const query = useQuery({
    queryKey: ["municipio-lista"],
    queryFn: () => Municipio.get({ size: 999 }),
    select: (response) => response.data.content,
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
